import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchDocumentHistory } from "../../../store/documentSignerShow/actions/fetchDocumentHistory";
import { findDocument } from "../../../store/documentSignerShow/actions/findDocument";
import { findSigners } from "../../../store/documentSignerShow/actions/findSigners";
import { markDocumentAsRead } from "../../../store/documentSignerShow/actions/markDocumentAsRead";
import findUsers from "../../../store/users/actions/findUsers";

export const ParamsWatcher: React.FC = () => {
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();

  useEffect(() => {
    dispatch(findDocument(id));
    dispatch(findSigners(id));
    dispatch(fetchDocumentHistory(id));
  }, [dispatch, id]);
  return <></>;
};
